"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Icon = _interopRequireDefault(require("./Icon"));
var _Chatbar = _interopRequireDefault(require("./Chatbar"));
var _Message = _interopRequireDefault(require("./Message"));
var _GlobalLoader = _interopRequireDefault(require("./GlobalLoader"));
var _i18n = _interopRequireDefault(require("../@i18n"));
var _store = require("../@api/store");
var _common = require("../@api/common");
var _index = require("../@hooks/index");
var _SeloHomologacao = _interopRequireDefault(require("../@assets/images/SeloHomologacao.svg"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var currentAppcenterState = '';

/**
 * AppCenter Ultrabar. A summary where all the apps can access appccenter basic operations.
 * @param {Object} props
 * @param {Boolean} props.themeSwitch toggle theme switch control at the bar
 * @param {() => void} props.onMenuIconClick function that is fired when the menu icon is clicked
 * @param {Boolean} props.showMenuIcon whether or not to show the menu icon
 * @param {String} props.appImageSrc url of the application logo
 * @param {Array} props.buttons Array of Objects with icon and onClick props
 * @param {Array} props.indicators Array of Objects with icon and onClick props
 * @param {() => void} props.onLogout Function that is fired when user logouts
 */
var UltraBar = function UltraBar(_ref) {
  var _whitelabel$app, _whitelabel$app2;
  var _ref$themeSwitch = _ref.themeSwitch,
    themeSwitch = _ref$themeSwitch === void 0 ? false : _ref$themeSwitch,
    onMenuIconClick = _ref.onMenuIconClick,
    _ref$showMenuIcon = _ref.showMenuIcon,
    showMenuIcon = _ref$showMenuIcon === void 0 ? true : _ref$showMenuIcon,
    app = _ref.app,
    _ref$buttons = _ref.buttons,
    buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
    _ref$indicators = _ref.indicators,
    indicators = _ref$indicators === void 0 ? [] : _ref$indicators,
    iconMenuComponents = _ref.iconMenuComponents,
    _ref$onLogout = _ref.onLogout,
    onLogout = _ref$onLogout === void 0 ? function () {} : _ref$onLogout;
  var _useState = (0, _react.useState)(_store.store.getState()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    storeState = _useState2[0],
    setStoreState = _useState2[1];
  var _useState3 = (0, _react.useState)('light'),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    currentTheme = _useState4[0],
    setCurrentTheme = _useState4[1];
  var _useState5 = (0, _react.useState)('hidden'),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    applicationsVisible = _useState6[0],
    setApplicationsVisible = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    chatbarVisible = _useState8[0],
    setChatbarVisible = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    userButtonVisible = _useState10[0],
    setUserButtonVisible = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    isHomologated = _useState12[0],
    setiIsHomologated = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    accesRequestVisible = _useState14[0],
    setAccesRequestVisible = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    personalAccesRequestVisible = _useState16[0],
    setPersonalAccesRequestVisible = _useState16[1];
  var _useWhitelabel = (0, _index.useWhitelabel)(storeState.appcenter),
    whitelabel = _useWhitelabel.whitelabel,
    whitelabelLicense = _useWhitelabel.whitelabelLicense;
  var hasLicense = !!whitelabelLicense;
  var whitelabelIsEnabled = hasLicense && ["paid", "free"].includes(whitelabelLicense.status);

  /**
   * Will define Light or Dark theme for the application
   * @param {string} theme
   */
  var updateCurrentTheme = function updateCurrentTheme(theme) {
    localStorage.setItem('theme', theme);
    setCurrentTheme(theme);
    document.body.classList.remove('dark');
    document.body.classList.remove('light');
    document.body.classList.add(theme);
  };
  /**
   * Toggle if the application menu is visible
   */
  var toggleApplicationsVisible = function toggleApplicationsVisible() {
    if (applicationsVisible === 'visible') {
      return setApplicationsVisible('hidden');
    }
    setApplicationsVisible('visible');
  };
  var toggleAccesRequestVisible = function toggleAccesRequestVisible() {
    if (accesRequestVisible === 'visible') {
      return setAccesRequestVisible('hidden');
    }
    setAccesRequestVisible('visible');
  };
  var togglePersonalAccesRequestVisible = function togglePersonalAccesRequestVisible() {
    if (personalAccesRequestVisible === 'visible') {
      return setPersonalAccesRequestVisible('hidden');
    }
    setPersonalAccesRequestVisible('visible');
  };
  /**
   * Toogle if the chatbar is visible
   */
  var toggleChatbar = function toggleChatbar() {
    setChatbarVisible(!chatbarVisible);
  };
  /**
   * Toggle if user options are visible
   */
  var toggleUserButtonVisible = function toggleUserButtonVisible() {
    setUserButtonVisible(!userButtonVisible);
  };
  var sso = function sso(app) {
    _store.services.appcenter.auth.sso(app)["catch"](function (r) {
      _store.services.message.show((0, _i18n["default"])('no.license.redirect'));
    });
  };
  (0, _react.useEffect)(function () {
    var _storeState$appcenter, _storeState$appcenter2;
    var authenticated = (_storeState$appcenter = storeState.appcenter) === null || _storeState$appcenter === void 0 ? void 0 : _storeState$appcenter.authenticated;
    var company = storeState === null || storeState === void 0 ? void 0 : (_storeState$appcenter2 = storeState.appcenter) === null || _storeState$appcenter2 === void 0 ? void 0 : _storeState$appcenter2.company;
    var franchiseeContract = company === null || company === void 0 ? void 0 : company.franchiseeContract;
    if (authenticated && franchiseeContract !== null && franchiseeContract !== void 0 && franchiseeContract.homologated) {
      setiIsHomologated(true);
    } else {
      setiIsHomologated(false);
    }
  }, [storeState.appcenter]);
  (0, _react.useEffect)(function () {
    if (!themeSwitch) return;
    var currentTheme = localStorage.getItem('theme');
    if (!currentTheme && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      currentTheme = 'dark';
    }
    updateCurrentTheme(currentTheme || 'light');
  }, [themeSwitch]);
  (0, _index.useInterval)(function () {
    var state = _store.store.getState();
    if (JSON.stringify(state) !== JSON.stringify(storeState)) {
      setStoreState(state);
    }
  }, "1s");
  var user = storeState.appcenter.user;
  var photoSize = 30;
  var userInitials = (0, _react.useMemo)(function () {
    var fullName = "".concat(user.firstName, " ").concat(user.lastName).trim().replace(/\s+/g, " ");
    var initials = fullName.split(" ").map(function (name) {
      return name[0];
    });
    initials = [initials[0], initials[initials.length - 1]];
    return initials.join("");
  }, [user]);
  var personalAccessRequestActive = false;
  if (storeState.appcenter.authenticated && storeState.appcenter.personalAccessRequests.length) {
    personalAccessRequestActive = storeState.appcenter.personalAccessRequests.find(function (p) {
      return p.active ? p : false;
    });
  }
  var externalAccessRequestActive = false;
  if (storeState.appcenter.authenticated && storeState.appcenter.personalAccessRequests.length) {
    externalAccessRequestActive = !!storeState.appcenter.accessRequests.find(function (p) {
      return p.active ? p : false;
    });
  }
  return [/*#__PURE__*/_react["default"].createElement("div", {
    id: "ultra-bar"
  }, !!onMenuIconClick && showMenuIcon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "button iconed left",
    onClick: onMenuIconClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faBars"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "app-image"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: (0, _common.getAppImageSrc)(app)
  }))), storeState.appcenter.authenticated && indicators.map(function (indicator, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i + indicator.value,
      className: "indicator"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: indicator.icon
    }), indicator.value);
  }), storeState.appcenter.authenticated && buttons.map(function (button, i) {
    if (button.hidden) return;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i + button.icon,
      className: "button iconed ".concat(button.extraClass || ''),
      onClick: button.onClick
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon left-icon"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: button.icon
    })), !!button.text && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, button.text), !!button.rightIcon && /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon right-icon",
      onClick: button.rightIconClick
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: button.rightIcon
    })));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-spacer"
  }), storeState.appcenter.authenticated && iconMenuComponents, storeState.appcenter.authenticated && storeState.appcenter.personalAccessRequests.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "button iconed options-button access-requests personal\n\t\t\t\t\t\t".concat(personalAccesRequestVisible, " ").concat(personalAccessRequestActive ? 'active' : '', "\n\t\t\t\t\t"),
    onClick: togglePersonalAccesRequestVisible
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faShieldAlt"
  }), !!personalAccessRequestActive && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, personalAccessRequestActive.companyName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "options"
  }, storeState.appcenter.personalAccessRequests.map(function (request) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "option column ".concat(request.status),
      key: request.uid,
      onClick: function onClick(e) {
        _store.services.appcenter.company.accessRequests.toggleActive(request);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "faUserShield"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text full-flex-horizontal"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, /*#__PURE__*/_react["default"].createElement("b", null, request.companyName)), request.status !== 'accepted' && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, (0, _i18n["default"])('access.request.pending.status')), request.status == 'accepted' && request.statusResponsible && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, (0, _i18n["default"])('access.request.personal.message', {
      user: request.statusResponsible.name
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "actions"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      onClick: function onClick(e) {
        _store.services.appcenter.company.accessRequests.decide(request.uid, 'denied');
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "faTimesCircle"
    })))));
  }))), storeState.appcenter.authenticated && storeState.appcenter.user.companyadmin && storeState.appcenter.accessRequests.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "button iconed options-button access-requests ".concat(accesRequestVisible),
    onClick: toggleAccesRequestVisible
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faShieldAlt"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "options"
  }, storeState.appcenter.accessRequests.map(function (request) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "option column ".concat(request.status),
      key: request.uid
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "faUserShield"
    })), request.status == 'accepted' && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, (0, _i18n["default"])('access.request.accepted.status')), request.status !== 'accepted' && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text"
    }, (0, _i18n["default"])('access.request.message', {
      user: request.user.name
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "actions"
    }, request.status !== 'accepted' && /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      onClick: function onClick(e) {
        _store.services.appcenter.company.accessRequests.decide(request.uid, 'accepted');
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "faCheckCircle"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      onClick: function onClick(e) {
        _store.services.appcenter.company.accessRequests.decide(request.uid, 'denied');
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "faTimesCircle"
    })))));
  }))), isHomologated && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: "Selo de Homologado"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "button iconed"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _SeloHomologacao["default"],
    alt: "Selo de Homologado"
  })))), storeState.appcenter.authenticated && /*#__PURE__*/_react["default"].createElement("div", {
    className: "button chat",
    onClick: toggleChatbar
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faPaperPlane"
  }))), themeSwitch && /*#__PURE__*/_react["default"].createElement("div", {
    className: "theme-switch ".concat(currentTheme),
    onClick: function onClick(e) {
      updateCurrentTheme(currentTheme === 'light' ? 'dark' : 'light');
    },
    key: "theme-switch"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, currentTheme === 'light' ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faSun"
  }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faMoon"
  }))), /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: "Inbox - Gest\xE3o de Tickets"
  }, storeState.appcenter.authenticated && (!hasLicense || whitelabelIsEnabled && whitelabel && !((_whitelabel$app = whitelabel[app]) !== null && _whitelabel$app !== void 0 && _whitelabel$app.hideSupportButton)) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "button iconed",
    onClick: function onClick() {
      return window.open('https://inbox.taugor.app/');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faHeadset"
  }))) : /*#__PURE__*/_react["default"].createElement("span", null)), storeState.appcenter.authenticated && /*#__PURE__*/_react["default"].createElement(_core.ClickAwayListener, {
    onClickAway: function onClickAway() {
      return setUserButtonVisible(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "button user-button ".concat(userButtonVisible ? 'visible' : 'hidden'),
    onClick: toggleUserButtonVisible
  }, /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
    src: user.photo,
    alt: "Foto de perfil",
    style: {
      width: photoSize,
      height: photoSize,
      fontSize: 12
    }
  }, userInitials), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, storeState.appcenter.user.firstName), /*#__PURE__*/_react["default"].createElement("div", {
    className: "user-options"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "option user"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "avatar"
  }, /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
    src: user.photo,
    alt: "Foto de perfil",
    style: {
      width: 2 * photoSize,
      height: 2 * photoSize,
      fontSize: 24
    }
  }, userInitials)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, storeState.appcenter.user.firstName, " ", storeState.appcenter.user.lastName), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, storeState.appcenter.user.user), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, storeState.appcenter.company.name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "option",
    onClick: function onClick(e) {
      _store.services.appcenter.auth.logout();
      onLogout();
    }
  }, (0, _i18n["default"])('logout'))))), storeState.appcenter.authenticated && (!hasLicense || whitelabelIsEnabled && whitelabel && !((_whitelabel$app2 = whitelabel[app]) !== null && _whitelabel$app2 !== void 0 && _whitelabel$app2.hideOtherProducts)) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "button iconed applications ".concat(applicationsVisible),
    onClick: toggleApplicationsVisible
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "https://appcenter.taugor.com.br/assets/images/arIZt5oBa.svg"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "application-options"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "apps"
  }, app !== 'dokia' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "app dokia",
    key: "dokia",
    onClick: function onClick(e) {
      sso('dokia');
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    key: "dokia-logo",
    src: (0, _common.getAppImageSrc)('dokia'),
    alt: "Dokia Logo"
  })), app !== 'collectame' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "app collectame",
    key: "collectame",
    onClick: function onClick(e) {
      sso('collectame');
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    key: "collectame-logo",
    src: (0, _common.getAppImageSrc)('collectame'),
    alt: "Collectame Logo"
  })), app !== 'workflux' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "app workflux",
    key: "workflux",
    onClick: function onClick(e) {
      sso('workflux');
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    key: "workflux-logo",
    src: (0, _common.getAppImageSrc)('workflux'),
    alt: "Workflux Logo"
  })), app !== 'lawdoc' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "app lawdoc",
    key: "lawdoc",
    onClick: function onClick(e) {
      sso('lawdoc');
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    key: "lawdoc-logo",
    src: (0, _common.getAppImageSrc)('lawdoc'),
    alt: "Lawdoc Logo"
  })))))), /*#__PURE__*/_react["default"].createElement(_Chatbar["default"], {
    windowFocused: storeState.browser.hasFocus,
    appcenterStore: storeState.appcenter,
    visible: chatbarVisible,
    setVisible: setChatbarVisible
  }), /*#__PURE__*/_react["default"].createElement(_Message["default"], {
    className: "redux-message",
    visible: storeState.message.visible,
    title: storeState.message.title,
    description: storeState.message.description,
    buttons: storeState.message.buttons
  }), !storeState.appcenter.isAuthContextCreated && /*#__PURE__*/_react["default"].createElement(_GlobalLoader["default"], {
    spin: true,
    instant: true,
    app: app
  })];
};
var _default = UltraBar;
exports["default"] = _default;